import { render, staticRenderFns } from "./qyxxbgDialog1.vue?vue&type=template&id=0a6fbb92&scoped=true&"
import script from "./qyxxbgDialog1.vue?vue&type=script&lang=js&"
export * from "./qyxxbgDialog1.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgDialog1.vue?vue&type=style&index=0&id=0a6fbb92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fbb92",
  null
  
)

export default component.exports